import React from '../services/React';
import UI from '../services/UI';

class Dropdown extends React.Component {
  constructor(props) {
    super(props);

    this.updateValue = this.updateValue.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.updateValue();
  }

  componentDidUpdate() {
    this.updateValue();
  }

  updateValue() {
    const { value } = this.props;
    const { requestChange } = this.el.getValueLink('value');
    requestChange(value);
  }

  handleChange(newValue) {
    // only propagate if the value changed
    if (this.props.value !== newValue && this.props.onChange) {
      this.props.onChange(newValue);
    }
  }

  render() {
    const { value, defaultValue, ...otherProps } = this.props;
    return <UI.dropDownSelect ref={el => this.el = el} {...otherProps} />;
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/commons/components/Dropdown.jsx